import type { InvoiceReferences, InvoiceResponse } from '../../api/types';
import { formatMoney, parsePaise } from '../payments/allocation';
import { formatIstDate } from '../payments/paymentDates';
export const invoiceMoney = (value: string) => formatMoney(parsePaise(value));
export function referenceEntries(refs: InvoiceReferences | null): Array<[string, string]> {
  if (!refs) return [];
  return [
    ['LR No.', refs.lrNumber],
    ['LR Date', refs.lrDate ? formatIstDate(refs.lrDate) : null],
    ['Consignor Invoice No.', refs.consignorInvoiceNo],
    ['Packages', refs.packages == null ? null : String(refs.packages)],
    ['Consignee', refs.consignee],
    ['Item', refs.itemName],
  ].filter((entry): entry is [string, string] => entry[1] != null && entry[1] !== '');
}
export function invoiceCopyText(invoice: InvoiceResponse): string {
  const { buyer, trip, tax, lines, references } = invoice.snapshot;
  return [
    `${invoice.snapshot.taxTreatment === 'EXEMPT' ? 'Bill of Supply' : 'Invoice'}: ${invoice.invoiceNumber}`,
    `Date: ${formatIstDate(invoice.snapshot.invoiceDate)}`,
    `Buyer: ${buyer.companyName ?? ''}`,
    `GSTIN: ${buyer.gstin ?? 'Not provided'}`,
    `Vehicle: ${trip.vehicleNumber ?? ''}`,
    `From → To: ${trip.pickupCity ?? ''} → ${trip.dropCity ?? ''}`,
    ...lines.map((l) => `${l.description} · SAC ${l.sac}: ${invoiceMoney(l.amount)}`),
    `Taxable: ${invoiceMoney(tax.taxableAmount)}`,
    ...(tax.mode === 'FCM'
      ? tax.lines.map((l) => `${l.name} @ ${l.rate} %: ${invoiceMoney(l.amount)}`)
      : [tax.note]),
    ...(invoice.snapshot.taxTreatment === 'EXEMPT'
      ? [
          `GST exempt supply. Reason: ${invoice.snapshot.exemption?.reason ?? ''}`,
          ...(invoice.snapshot.exemption?.reference
            ? [`Exemption reference: ${invoice.snapshot.exemption.reference}`]
            : []),
        ]
      : []),
    `Total: ${invoiceMoney(tax.grandTotal)}`,
    ...referenceEntries(references).map(([label, value]) => `${label}: ${value}`),
  ].join('\n');
}
